import { Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { map, of, switchMap } from 'rxjs';
import { Customers } from 'server/shared/collections/customers';
import { Users } from 'server/shared/collections/users';
import { RoleEnum } from 'server/shared/models/role.enum';
import { DispoUser, RequesterUser, User } from 'server/shared/models/user';
import { CustomerService } from '../../services/customer.service';
import { ImpersonateService } from '../../services/impersonate.service';
import { UserService } from '../../services/user.service';
import { SidenavService } from '../sidenav.service';

@Component({
  selector: 'app-header',
  templateUrl: 'header.component.html',
  styleUrls: ['header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  loggedInUser?: User;
  roleEnum = RoleEnum;

  canSwitchCustomer$ = this.userService.readyUser$.pipe(
    switchMap((user) => {
      if (user.role === RoleEnum.DISPO) {
        if (user.isAdmin) {
          return of(true);
        }
        return Customers.find({ dispoIds: user._id }).pipe(
          map((customers) => customers.length > 1),
        );
      }
      if (user.role === RoleEnum.REQUESTER) {
        return Customers.find({ requesterIds: user._id }).pipe(
          map((customers) => customers.length > 1),
        );
      }
      return of(false);
    }),
  );

  isDemo$ = this.customerService.customersOfUser$.pipe(
    map((customers) => customers.some((customer) => customer.isDemo)),
  );

  demoValidUntil$ = this.customerService.customersOfUser$.pipe(
    map(
      (customers) =>
        customers.find((customer) => customer.demoValidUntil)?.demoValidUntil,
    ),
  );

  demoInstanceNumber$ = this.customerService.customersOfUser$.pipe(
    map(
      (customers) =>
        customers.find((customer) => customer.isDemo)?.demoInstanceNumber,
    ),
  );

  private userTracker?: Tracker.Computation;
  isImpersonating$ = this.impersonateService.isImpersonating$;

  constructor(
    private sidenavService: SidenavService,
    private ngZone: NgZone,
    private customerService: CustomerService,
    private impersonateService: ImpersonateService,
    private userService: UserService,
  ) {}

  ngOnInit(): void {
    this.userTracker = Tracker.autorun(() => {
      this.ngZone.run(() => {
        this.loggedInUser = Users.findOne(Meteor.userId());
      });
    });
  }

  ngOnDestroy() {
    if (this.userTracker) {
      this.userTracker.stop();
    }
  }

  isDispo(user?: User): user is DispoUser {
    return user?.role === RoleEnum.DISPO;
  }

  isRequester(user?: User): user is RequesterUser {
    return user?.role === RoleEnum.REQUESTER;
  }

  public onButtonClick(): void {
    this.sidenavService.toggle();
  }

  public onReturnClick(): void {
    this.impersonateService.returnToOriginalUser().catch(() => {
      // Error handling is done in the service
    });
  }
}
